import React from 'react';
import VimeoHelper from '../../lib/VimeoHelper';
import { VideoLessonData } from '../../types';

type Props = {
    lesson: VideoLessonData,
}

export default ({ lesson }: Props) => {
    const embedHtml = VimeoHelper.getEmbedCode(lesson.vimeoId, lesson.title);

    return (
        <div>
            <h2>{lesson.title}</h2>
            <div dangerouslySetInnerHTML={{ __html: embedHtml }} />
        </div>
    );
};
